<template>
  <div style="width:100%">
<!-- {{$store.state.orders}} -->
       <v-row no-gutters style="width:100%" align="center" justify="center">
           <v-col cols="12">
               <v-subheader  style="color:white;width:100%;background-color:#6A8260">
                   <v-row>
                       <v-spacer></v-spacer>
                       <p class="text-center text-body  font-weight-bold">Orders</p>
                       <v-spacer></v-spacer>
                   </v-row>
               </v-subheader>
                <v-simple-table style="width:100%">
    <template v-slot:default>
      <thead>
        <tr>
             <th class="text-center">
            Order id
          </th>
            <th class="text-center">
            Order Details
          </th>
         
          <th class="text-center">
            Customer
          </th>
          <th class="text-center">
            Total <br /> (USD)
          </th>
          <th class="text-center">
            Fulfilment
          </th>
          <th class="text-center">
            State
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="i in item"
          :key="i.id"
        >
          <td>{{ i.id}}</td>
          <td>{{ i.lineItems[0].name }} {{i.lineItems[0].quantity}} qty</td>
         
          <td>{{ i.customerId }}</td>
         
          <td>{{ i.lineItems[0].basePriceMoney.amount*0.01 }}</td>
          <td>{{ i.state }}</td>
          <td><v-select
          :items="state"
          @change="update(i.state,i.id)"
          v-model="i.state"
          :value="i.status"
        ></v-select>
      </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
           </v-col>
       </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
data(){
    return {
        item:[],
        state:['OPEN','COMPLETED','CANCELLED']
    }
},
methods:{
    update(text,id){
        // alert(text,id)
        axios.post('https://zaastry-node.herokuapp.com/order/update',{
            text:text,
            id:id
        }).then(res=>{
            console.log(res.data)
        }).catch(err=>{
            console.log(err)
        })

    }
},
async mounted(){
    
      await axios.get('https://zaastry-node.herokuapp.com/order').then(res=>{
        this.$store.commit("setOrder",res.data)
        this.item=res.data
      })
   
  }
}
</script>

<style>

</style>